import React from "react";
import { CreditCard } from "react-feather";

import SectionLayout from "../../layouts/SectionLayout";
import { RouteInfoType } from "../../types/types";
import PaymentsPage from "./pages/PaymentsPage";

const paymentsRoutes = [
    {
        id: "payments",
        path: "/payments/",
        name: "Платежи",
        icon: <CreditCard />,
        component: SectionLayout,
        nonCollapsable: true,
        routes: [
            {
                path: "/payments/general",
                exact: true,
                name: "Платежи",
                component: PaymentsPage,
            },
        ],
    },
];

export default paymentsRoutes as RouteInfoType[];
